import { useTranslation } from 'react-i18next';

const HealerSection = () => {
  const { t } = useTranslation('common');

  const credentials = t('healer.credentials', { returnObjects: true }) as string[];
  const qualities = t('healer.qualities', { returnObjects: true }) as { icon: string; title: string; desc: string }[];

  return (
    <section className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-xs tracking-[0.25em] uppercase text-amber-600 font-medium mb-3">
            {t('healer.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-light text-gray-900">
            {t('healer.title')}
          </h2>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          {/* Left: Photo */}
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_0925594e10be45ef44c18d9e9c85e1b9_c9b1e548.jpg"
                  alt={t('healer.name')}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-5 -right-4 bg-teal-800 text-white rounded-2xl px-5 py-4 shadow-lg">
                <p className="text-2xl font-semibold leading-none">{t('healer.yearsNum')}</p>
                <p className="text-xs text-teal-200 mt-1 whitespace-nowrap">{t('healer.yearsLabel')}</p>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex-1 pt-2">
            {/* Name & Title */}
            <div className="mb-6">
              <h3 className="text-2xl md:text-3xl font-medium text-gray-900 mb-1">
                {t('healer.name')}
              </h3>
              <p className="text-amber-600 text-sm font-medium tracking-wide">
                {t('healer.role')}
              </p>
            </div>

            {/* Bio */}
            <p className="text-gray-600 leading-relaxed text-sm md:text-base mb-8">
              {t('healer.bio')}
            </p>

            {/* Credentials */}
            <div className="mb-8">
              <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
                {t('healer.credentialsTitle')}
              </p>
              <ul className="space-y-2">
                {credentials.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-gray-700">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-base"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Qualities */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {qualities.map((q, i) => (
                <div key={i} className="bg-white rounded-xl p-4 shadow-sm border border-stone-100">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-teal-50 mb-3">
                    <i className={`${q.icon} text-teal-700 text-lg`}></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-800 mb-1">{q.title}</p>
                  <p className="text-xs text-gray-500 leading-relaxed">{q.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealerSection;
